<!-- Breadcrumb -->
<app-campaign-breadcrumb
  [stateAction]="stateAction"
  [messageInstanceId]="messageInstanceId"
  [campaignId]="campaignId"
  [actionId]="actionId"
  [actionTypeCode]="actionTypeCode"
  [actualStep]="actualStep">
</app-campaign-breadcrumb>

<div class="ui-g-12 campaign-step-title flex-align-center">
  <h2>{{ 'campaign.touchpointLayoutSetup' | translate }}</h2>
</div>
<section class="ui-g-12">
  <!-- Slect External Workflow 
  <div class="ui-g-12 workflow-container">
    <div class="ui-g-12 ui-md-6">
      <h3>Workflow</h3>
      <p-dropdown
        class="coupon-dropdown"
        [options]="workflowList"
        [style]="{'width':'100%'}"
        [(ngModel)]="selectedWorkflow">
      </p-dropdown>
    </div>
    <div class="ui-g-12 ui-md-6"></div>
  </div>-->
  <!-- Lista Touchpoints -->
  <div class="ui-g-12 touchpoint-container" *ngFor="let tp of touchpoint_default">
    <div class="ui-g-12 ui-md-3">
      <h3>{{tp.description}}</h3>
    </div>
    <div class="ui-g-12 ui-md-3">
      <div class="campaign-button flex-align-center" (click)="openLayoutDialog(tp)">
        <div class="campaign-button__label">
          {{ 'campaign.setLayout' | translate }}
        </div>
        <div class="text-right">
          <i class="fa fa-arrow-right icon-campaign-arrow"></i>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-6"></div>
  </div>
  
  <div class="ui-g-12 touchpoint-container" *ngFor="let tp of touchpoints">
    <div class="ui-g-12 ui-md-3">
      <h3>{{tp.description}}</h3>
    </div>
    <div class="ui-g-12 ui-md-3">
      <div class="campaign-button flex-align-center" (click)="openLayoutDialog(tp)">
        <div class="campaign-button__label">
          {{ 'campaign.setLayout' | translate }}
        </div>
        <div class="text-right">
          <i class="fa fa-arrow-right icon-campaign-arrow"></i>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-3" *ngIf="tp.code == 1">
      <div class="previewLayout" (click)="anteprimaCoupon()">
        <div class="previewLayout__label">
          {{ 'cluster_ochannel.preview' | translate }}
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Save -->
<section class="ui-g-12" style="padding-bottom: 100px;">
  <div class="ui-g-12 ui-md-10 text-right">
    <button
      style="margin-bottom: 20px;"
      pButton
      (click)="save()"
      type="button"
      class="k-generic-btn"
      label="{{ 'common.save' | translate }}">
    </button>
    <p style="color: #d00; margin: 0;" *ngIf="missingLayout">{{ 'campaign.missingLayoutErrorMsg' | translate }}</p>
  </div>
</section>

<!-- Dialog Configurazione Layout -->
<p-dialog
  id="set-layout-dialog"
  class="campaign-dialog"
  [positionTop]="40"
  [positionLeft]="'50%'"
  [header]="'campaign.setLayout' | translate"
  [width]="700"
  [(visible)]="showLayoutDialog && formData"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeLayoutDialog()">
  <app-kv-json-form-schema
    *ngIf="formData"
    [formData]="formData"
    (formSubmitted)="saveLayout($event)">
  </app-kv-json-form-schema>
</p-dialog>

<p-dialog 
  class="campaign-dialog" 
  *ngIf="showPreview" 
  [(visible)]="showPreview" 
  [positionTop]="40" 
  [positionLeft]="'50%'"
  [header]="'campaign.previewCoupon' | translate"
  [modal]="true" 
  [draggable]="false" 
  [closable]="true">
  <div *ngIf="showPreviewError" style="color: #d00;"> {{ showPreviewError}} </div>
  <img [src]="imagePath">
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-layout-setup/coupon-layout-setup.component.html